export default __webpack_public_path__ + "static/media/My_car_website_images-8_21.a9fed451.jpg";